<template>
  <v-card flat>
    <v-overlay :value="isLoading()">
      <v-progress-circular indeterminate size="100" />
    </v-overlay>
    <v-card-text>
      <link-carte />
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import LinkCarte from "@/components/LinkCarte";

export default {
  name: "VueCarte",
  components: { LinkCarte },
  computed: {
    ...mapGetters({
      cartesIsLoading: "carte/list/isLoading",
      structuresIsLoading: "structure/list/isLoading",
      drIsLoading: "dr/list/isLoading",
      carteUpdateIsLoading: "carte/update/isLoading",
    }),
  },
  methods: {
    isLoading() {
      return (
        this.cartesIsLoading ||
        this.structuresIsLoading ||
        this.drIsLoading ||
        this.carteUpdateIsLoading
      );
    },
  },
};
</script>

<style scoped></style>
